import type { InventoryItem } from '../types/domain'

/**
 * Items minted by the in-app debug injector carry a `debug` tag. Auto-claim
 * resolves these locally (no backend push) so visual testing never triggers a
 * server claim for an id the backend doesn't know about.
 */
export const isDebugItem = (item: InventoryItem): boolean => item.tags.includes('debug')
